import * as classnames from 'classnames';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Header, HeaderLabel } from './AccordionStyle';
import { ContentSpacing } from '@estee/elc-base-theme';
import { AccordionIcons } from './AccordionIcons';
import { iconTheme } from '../theme/default-theme';

export interface ILabelSlideProps {
    id: string;
    title: string;
    iconType?: string;
    className?: string;
    index?: number;
    isOpen?: boolean;
    isLigthAccordion?: boolean;
    dataTestId?: string;
    hidden?: boolean;
    onChange?(openIndex: number): void;
    collapseIconAriaLabel?: string;
    expandIconAriaLabel?: string;
}

export interface IWrapperContentProps {
    isOpen?: boolean;
}

const iconCss = css`
    margin-left: auto;
    stroke-width: 2px;
    width: ${ContentSpacing.space20};
    height: ${ContentSpacing.space20};

    [dir='rtl'] & {
        margin-left: 0;
        margin-right: auto;
    }
`;

const AccordionIconsStyled = styled(AccordionIcons)`
    ${iconCss};
    ${iconTheme};
`;

const StyledWrapperContent = styled.div<IWrapperContentProps & React.HTMLProps<HTMLInputElement>>`
    padding-top: ${ContentSpacing.space12};
    display: ${props => (props.isOpen ? 'block' : 'none')};
`;

export class LabelSlide extends React.Component<ILabelSlideProps> {
    constructor(props: ILabelSlideProps) {
        super(props);
        this.handleHeaderKeyboardAccess = this.handleHeaderKeyboardAccess.bind(this);
    }

    private onClick = () => {
        if (this.props.onChange) {
            this.props.onChange(this.props.index || 0);
        }
    };

    private handleHeaderKeyboardAccess(event: React.KeyboardEvent<HTMLDivElement>): void {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.onClick();
        }
    }

    private displayContent() {
        return (
            <StyledWrapperContent
                isOpen={this.props.isOpen}
                className="elc-label-slide-content js-label-slide-content"
            >
                {this.props.children}
            </StyledWrapperContent>
        );
    }

    public render() {
        const headerId = `acc-${this.props.id}`;
        const isOpen = this.props.isOpen || false;
        const labelSlideClass = classnames(
            this.props.className,
            'elc-label-slide',
            'js-label-slide'
        );

        return (
            <div hidden={this.props.hidden} className={labelSlideClass}>
                <Header
                    id={headerId}
                    onClick={this.onClick}
                    onKeyPress={this.handleHeaderKeyboardAccess}
                    title={this.props.title}
                    tabIndex={0}
                    role="button"
                    data-test-id={this.props.dataTestId || ''}
                    aria-controls={headerId}
                    aria-expanded={isOpen}
                    isOpen={isOpen}
                    className="elc-accordion-header js-accordion-header"
                >
                    <HeaderLabel
                        id={`${headerId}-label`}
                        className="elc-header-label js-header-label"
                    >
                        {this.props.title}
                    </HeaderLabel>
                    <AccordionIconsStyled
                        isOpen={this.props.isOpen}
                        iconType={this.props.iconType}
                        collapseIconAriaLabel={this.props.collapseIconAriaLabel}
                        expandIconAriaLabel={this.props.expandIconAriaLabel}
                    />
                </Header>
                {this.displayContent()}
            </div>
        );
    }
}
